import {
	FORGOT_PASSWORD_SUCCESS,
 	FORGOT_PASSWORD_CHECK_SUCCESS,
  	FORGOT_PASSWORD_RESET_SUCCESS,
	FORGOT_PASSWORD_SET_TOKEN,
	REQUEST_RESET_CLOSE_POPUP,
	REQUEST_RESET_OPEN_SUCCESS,
	REQUEST_RESET_OPEN_FAIL,
	RESET_CLOSE_POPUP,
	RESET_OPEN_SUCCESS,
	RESET_OPEN_FAIL
} from "../actions/types";

const INIT_STATE = {
  forgotPasswordToken: "",
  forgotPasswordTokenStatus: {},
  forgotPasswordStep: 1,
  displayPopupRequestSuccess: false,
  displayPopupRequestFail: false,
  displayPopupResetSuccess: false,
  displayPopupResetFail: false,
  displayMessage:""
};

export default (state = INIT_STATE, action) => {

	switch (action.type) {
		case FORGOT_PASSWORD_SUCCESS: {
			return {
				...state,
				forgotPasswordToken: "",
				forgotPasswordTokenStatus: {},
				forgotPasswordStep: 1,
			};
		}
		case FORGOT_PASSWORD_SET_TOKEN: {
			return {
				...state,
				forgotPasswordToken: action.payload,
			}
		}
		case FORGOT_PASSWORD_CHECK_SUCCESS: {
			return {
				...state,
        		forgotPasswordTokenStatus: action.payload,
        		forgotPasswordStep: 2,
			};
		}
		case FORGOT_PASSWORD_RESET_SUCCESS: {
			return {
				...state,
        		forgotPasswordStep: 3,
			};
		}
		case REQUEST_RESET_CLOSE_POPUP:
			document.body.classList.remove('modal-open');
			return INIT_STATE;
		case REQUEST_RESET_OPEN_SUCCESS:
			document.body.classList.add('modal-open');
			return {
			...state,
				displayPopupRequestSuccess: true,
			};
		case REQUEST_RESET_OPEN_FAIL:
			document.body.classList.add('modal-open');
			return {
				...state,
				displayPopupRequestFail: true,
				displayMessage:action.payload,
			};
		case RESET_CLOSE_POPUP:
			document.body.classList.remove('modal-open');
			return INIT_STATE;
		case RESET_OPEN_SUCCESS:
			document.body.classList.add('modal-open');
			return {
				...state,
				displayPopupResetSuccess: true,
			};
		case RESET_OPEN_FAIL:
			document.body.classList.add('modal-open');
			return {
				...state,
				displayPopupResetFail: true,
				displayMessage:action.payload,
			};
				
		default:
			return state;
	}
};
